module.exports = __webpack_public_path__ + "static/media/mail.86ddd6df.svg";